// @truco6/ui: tokens do design system, baralho em SVG e avatares do elenco.
import { AVATARES } from './avatares.ts';

export { cores, fontes, URL_FONTES } from './tokens.ts';
export {
  NAIPES, POSTOS, VERSO_DA_CASA, cartaSVG, imagemDaCarta, nomeDaCarta, nomeDoId, versoSVG,
} from './cartas.ts';
export type { Naipe, OpcoesVerso } from './cartas.ts';
export { SIMBOLO } from './marca.ts';
export { AVATARES } from './avatares.ts';
export type { Avatar } from './avatares.ts';

const cacheAvatar = new Map<string, string>();

// Data URI do avatar pelo id ('av-bi'), ou null se o id não existe.
export function imagemDoAvatar(id: string | null | undefined): string | null {
  if (!id) return null;
  let uri = cacheAvatar.get(id);
  if (!uri) {
    const a = AVATARES.find((x) => x.id === id);
    if (!a) return null;
    uri = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(a.svg);
    cacheAvatar.set(id, uri);
  }
  return uri;
}

// Avatar do elenco pelo nome (os bots usam os nomes do elenco).
export function avatarDoNome(nome: string): string | null {
  return AVATARES.find((a) => a.nome === nome)?.id ?? null;
}
